module.exports = __webpack_public_path__ + "static/img/89004F_2_3_C_20200330_LC.112f8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89004F_2_3_C_20200330_LC.png
// module id = ober
// module chunks = 0